import { useState } from "react";
import {
  CloseCircleOutlined,
  DollarCircleTwoTone,
  DownloadOutlined,
  DownOutlined,
  FileImageOutlined,
  MoneyCollectOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Alert, Avatar, Button, Card, Col, Divider, Form, Image, Input, List, message, Row, Space, Tag, Upload } from "antd";
import { v4 as uuidv4 } from "uuid";
import constants from "../../constants";
import axios from "axios";
import { useForm } from "antd/es/form/Form";
import { useAuth } from "../../contexts/authContext";

const RegisterPayment = ({ defaultList, updateRow, leadId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [form] = useForm();
  const { getToken } = useAuth();

  const registerPayment = async (formValues) => {
    const formData = new FormData();
    formData.append("screenshot", formValues.screenShotFile.file);
    formData.append("amount", formValues.amount);

    try {
      setLoading(true);
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };
      const url = `${constants.NEW_DOMAIN}/api/v1/channelPartnerLeads/registerPayment/${leadId}`;
      const res = await axios.post(url, formData, {
        headers,
      });

      const { amount = 0, screenShotUrl = "", status = "unverified" } = res.data?.data || {};

      updateRow(leadId, "paymentRecords", [
        ...defaultList,
        {
          screenShotUrl,
          status,
          amount,
        },
      ]);
      setFormVisible(false);
      form.resetFields();
      setLoading(false);
      message.success("Upload successfull , our team will review it shortly.");
    } catch (error) {
      setLoading(false);
      setError(error.message || "upload failed , try again later");
    }
  };

  return (
    <div>
      {defaultList?.length > 0 && (
        <List
          itemLayout="horizontal"
          dataSource={defaultList || []}
          renderItem={(item, index) => (
            <List.Item
              actions={[
                <Tag color={item.status === "verified" ? "green" : item.status === "unverified" ? "red" : "gold"}>{item.status}</Tag>,
                //   <a
                //     onClick={()=>{
                //         // remove the current file from fileList but how will i get the id?

                //     }}
                //   >
                //     Delete
                //   </a>,
              ]}
            >
              <List.Item.Meta
                title={
                  <a href={item.screenShotUrl} target="_blank">
                    Amount : ₹{item.amount}
                  </a>
                }
                avatar={<Image src={item.screenShotUrl} preview width={"50px"} />}
                description={item.comments || "No comments from admin yet"}
              />
            </List.Item>
          )}
        />
      )}

      <Button
        type="link"
        onClick={() => {
          setFormVisible(!formVisible);
          form.resetFields();
        }}
      >
        {formVisible ? "Cancel" : "+ Register New Payment"}
      </Button>

      {formVisible && (
        <Form form={form} layout="vertical" size="small" style={{ backgroundColor: "lightyellow", padding: "10px", margin: "10px" }} onFinish={registerPayment}>
          <Form.Item name="amount" label="Amount" rules={[{ required: true }]}>
            <Input prefix="INR" type="number" />
          </Form.Item>
          <Form.Item name="screenShotFile" label="Payment Screenshot" rules={[{ required: true }]}>
            <Upload
              listType="picture"
              beforeUpload={() => {
                return false;
              }}
            >
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
          </Form.Item>
          {error && <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable />}

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Register New Payment
              </Button>
            </Space>
          </Form.Item>
        </Form>
      )}
    </div>
  );

  //   return (
  //     <>
  //       <Upload {...props} listType="picture">
  //         {/* <Button icon={<UploadOutlined />}>Register Payment</Button> */}
  //       </Upload>
  //       {registerFormVisible && (
  //         <Form style={{ marginTop: "20px" }} layout="inline">
  //           <Form.Item name="amount" label="Amount" rules={[{ required: true }]}>
  //             <Input prefix="INR" type="number" />
  //           </Form.Item>
  //           <Form.Item name="screenShotFile" label="Payment Screenshot" rules={[{ required: true }]}>
  //             <Upload
  //               listType="picture"
  //               beforeUpload={(file) => {
  //                 setFileList([...fileList, file]);
  //                 return false;
  //               }}
  //               onRemove={(file) => {
  //                 const index = fileList.indexOf(file);
  //                 const newFileList = fileList.slice();
  //                 newFileList.splice(index, 1);
  //                 setFileList(newFileList);
  //               }}
  //               maxCount={1}
  //             >
  //               <Button icon={<UploadOutlined />}>Upload</Button>
  //             </Upload>
  //           </Form.Item>
  //         </Form>
  //       )}

  //       <Row gutter={14}>
  //         <Col>
  //           {/* <Button type="primary" onClick={handleUpload} disabled={fileList.length === 0} loading={uploading} style={{ marginTop: 16 }}> */}
  //           <Button type="primary" onClick={handleUpload} loading={uploading} style={{ marginTop: 16 }}>
  //             {uploading ? "Uploading" : "Update"}
  //           </Button>
  //         </Col>
  //         <Col>
  //           <Button
  //             type="link"
  //             onClick={() => {
  //               setRegisterFormVisible(true);
  //             }}
  //             disabled={registerFormVisible}
  //             style={{ marginTop: 16 }}
  //           >
  //             + Register New Payment
  //           </Button>
  //         </Col>
  //       </Row>
  //     </>
  //   );
};
export default RegisterPayment;
